import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import mutations from '@/store/mutations';
// eslint-disable-next-line import/no-cycle
import actions from '@/store/actions';
import * as getters from '@/store/getters';
import DashboardModule from './modules/dashboard';
import DunningModule from './modules/dunning';
import DunningDashboardModule from './modules/dunning-dashboard';
import ReactivationModule from './modules/reactivation';
import SubscriptionAnalyticsModule from './modules/subscription-analytics';
import PermissionModule from './modules/permissions';
import AIModule from './modules/ai';
import { LOAD_STATE } from './shared';

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      paths: ['token', 'authStatus', 'user', 'promo', 'asOrg', 'selectedPlanType', 'confidential', 'testMode'],
    }),
  ],
  state: {
    user: null,
    confidential: false,
    testMode: false,
    token: window.localStorage.getItem('token') || '',
    authStatus: null,
    twoFactorStatus: null,
    twoFactorErrorMessage: null,
    customerActivities: [],
    org: null,
    syncUserLoadState: LOAD_STATE.UNLOADED,
    syncOrgLoadState: LOAD_STATE.UNLOADED,
    // capture what the blueprint looks like in mongo
    blueprints: {},
    segments: {},
    webhooks: {},
    campaignBlueprints: {},
    campaignBlueprintEmailCounts: {},
    dunningExclusions: {},
    dunningExclusionBlockCounts: {},
    reactivationCampaignBlueprints: {},
    reactivationCampaignBlueprintEmailCounts: {},
    reactivationExclusions: {},
    currentBlueprintId: null,
    selectedTemplate: null,
    orgs: [],
    stripeData: {
      couponsLoadState: LOAD_STATE.UNLOADED,
      pricesLoadState: LOAD_STATE.UNLOADED,
    },
    promo: null,
    productIntent: null,
    asOrg: null,
    selectedPlanType: 'undecided',
    previewInline: false,
    previewMergeFields: {},
    issues: [],
    ...DashboardModule.state,
    ...DunningModule.state,
    ...DunningDashboardModule.state,
    ...ReactivationModule.state,
    ...SubscriptionAnalyticsModule.state,
    ...AIModule.state,
    ...PermissionModule.state,
  },
  actions: {
    ...actions,
    ...DashboardModule.actions,
    ...DunningModule.actions,
    ...DunningDashboardModule.actions,
    ...ReactivationModule.actions,
    ...SubscriptionAnalyticsModule.actions,
    ...AIModule.actions,
    ...PermissionModule.actions,
  },
  getters: {
    ...getters,
    ...DashboardModule.getters,
    ...DunningModule.getters,
    ...DunningDashboardModule.getters,
    ...ReactivationModule.getters, // order matters, Reactivation uses some Dunning getters
    ...SubscriptionAnalyticsModule.getters,
    ...AIModule.getters,
    ...PermissionModule.getters,
  },
  mutations: {
    ...mutations,
    ...DashboardModule.mutations,
    ...DunningModule.mutations,
    ...DunningDashboardModule.mutations,
    ...ReactivationModule.mutations,
    ...SubscriptionAnalyticsModule.mutations,
    ...AIModule.mutations,
    ...PermissionModule.mutations,
  },
});
